import React, { Component } from 'react';
import { Menu } from 'antd';
import API_URL from '../../common/url';
import $ from '../../common/AjaxRequest';
import { queryApprovalUserCached } from '../../common/permissionCache';

const SubMenu = Menu.SubMenu;
const rootSubmenuKeys = ['sub1', 'sub2', 'sub3'];

class UserSider extends Component {
    state = {
        isChargeArea:null,
        isInvAreaLeader:null,
        isInvPM:null,
        openKeys: this.props.openKeys || [],
        selectKey: this.props.selectKey || '',
        FINCanViewUserEfficiency: false,
    }

    componentDidMount(){
        this.queryApprovalUser();
        this.queryUserAdditionalPermissions();
    }
     // 查询|| isCSAL权限（马文文）
     queryApprovalUser = () => {
        queryApprovalUserCached('FIN_MODULE,TEACH_LEADER', res => {
            const { isChargeArea, isInvAreaLeader, isInvPM } = res;
            this.setState({ isChargeArea, isInvAreaLeader, isInvPM });
        });
    }

    // 部分FIN开放人员管理-人员效率
    queryUserAdditionalPermissions = () => {
        const options = {
            method: 'POST',
            url: API_URL.user.queryUserAdditionalPermissions,
            data: { },
            dataType: 'json',
            doneResult: res => {
                const { list = [] } = res;
                const FINCanViewUserEfficiency = list.some( el => el == 'EMPLOYEE_MANAGER_EMP_EFFICIENCY')
                this.setState({ FINCanViewUserEfficiency })
            },
        };
        $.sendRequest(options);
    }

    onOpenChange = (openKeys) => {
        this.setState({ openKeys });
    }

    render() {
        const { selectKey, openKeys, FINCanViewUserEfficiency } = this.state;
        const { isChargeArea, isInvPM, isInvAreaLeader } = this.state;
        const { curRole } = sessionStorage;
        const isCTA = curRole == 'CTA';
        const isPM = curRole == 'PM';
        const isBO = curRole == 'BO';
        const isCRC = curRole == 'CRC';
        const isCRCC = curRole == 'CRCC';
        const isCRCM = curRole == 'CRCM';
        const isVP = curRole == 'VP';
        const isFIN = curRole == 'FIN';
        const isPML = curRole == 'PML';
        const isBD = curRole == 'BD';
        const isBDO = curRole == 'BDO';
        const isBDM = curRole == 'BDM';
        const isHRRC = curRole == 'HRRC';
        const isCSAL = curRole == 'CSAL';
        const isBAL = curRole == 'BAL';
        return (
            <aside className="sidebar">
                <Menu
                    mode="inline"
                    selectedKeys={[selectKey]}
                    openKeys={openKeys}
                    onOpenChange={this.onOpenChange}
                >
                        <SubMenu key="sub1" title={'人员数据'}>
                            {
                                !(isBD || isBDM) &&
                                <Menu.Item key="userInfo">
                                    <a href="#/user/userInfo">人员信息</a>
                                </Menu.Item>
                            }
                            {
                                !isFIN && !(isCRC || isBD || isBDM ||isBDO || (isCRC && isChargeArea) || isHRRC || isBAL) &&
                                <Menu.Item key="userResume">
                                    <a href="#/user/userResume">人员简历</a>
                                </Menu.Item>
                            }
                            {
                                (isBO || isPML || isCRCM || isCRCC || isCSAL) &&
                                <Menu.Item key="userFolder">
                                    <a href="#/user/userFolder">人员文件夹</a>
                                </Menu.Item>
                            }
                            {
                                !isFIN && !(isBD || isBDM || (isCRC && isChargeArea) || isHRRC) &&
                                <Menu.Item key="userPlan">
                                    <a href="#/user/userPlan">人员安排</a>
                                </Menu.Item>
                            }
                            {
                            !isPML && !(isBD || isBDO || isBDM || (isCRC && isChargeArea) || isHRRC || isBAL) &&
                                <Menu.Item key="userRequire">
                                    <a href="#/user/require">人员需求</a>
                                </Menu.Item>
                            }
                            {
                                !(isPML || (isCRC && isChargeArea) || isHRRC || isBAL) &&
                                <Menu.Item key="userTransfer">
                                    <a href="#/user/transfer">人员交接</a>
                                </Menu.Item>
                            }
                            {
                                (isBO || isCSAL || isVP || isCRCC || isCRCM || isInvAreaLeader || isInvPM || isPML) &&
                                <Menu.Item key="UserDimission">
                                    <a href="#/user/UserDimission">人员离职</a>
                                </Menu.Item>
                            }
                            {
                                (isBO || isCSAL || isCTA || isVP || isFIN || isPML || isHRRC) &&
                                <Menu.Item key="userManhour">
                                    <a href="#/user/userManhour">人员工时</a>
                                </Menu.Item>
                            }
                            {
                                !isFIN && !isHRRC && !isBAL &&
                                <Menu.Item key="pmTransfer">
                                    <a href="#/user/pmTransfer">PM交接</a>
                                </Menu.Item>
                            }
                            {
                                (isBO || isCSAL || isCTA || isPML) &&
                                <Menu.Item key="dashedReport">
                                    <a href="#/user/DashedReport">PM虚线汇报线</a>
                                </Menu.Item>
                            }
                            {
                                (isBO || isCSAL || isHRRC || isBDO || isBAL) &&
                                <Menu.Item key="fieldLeader">
                                    <a href="#/user/fieldLeader">领域leader</a>
                                </Menu.Item>
                            }
                            {
                                !(isCRC && isChargeArea) && !isHRRC && !isBAL && 
                                <Menu.Item key="userDistribution">
                                    <a href="#/user/UserDistribution">人员分布</a>
                                </Menu.Item>
                            }
                            {
                                !(isBD || isBDO || isBDM || (isCRC && isChargeArea) || isHRRC || isBAL) &&
                                <Menu.Item key="userAnalysis">
                                    <a href="#/user/UserAnalysis">人员分析</a>
                                </Menu.Item>
                            }
                        </SubMenu>
                        {(!isBAL && !isBDO) &&
                            <SubMenu key="sub2" title={'效率数据'}>
                            {
                                (isFIN ? FINCanViewUserEfficiency : !(isBD || isBDO || isBDM)) &&
                                <Menu.Item key="userEfficiency">
                                    <a href="#/user/userEfficiency">人员效率</a>
                                </Menu.Item>
                            }
                            {
                                (isFIN ? FINCanViewUserEfficiency :  !(isBD || isBDO || isBDM )) &&
                                <Menu.Item key="output">
                                    <a href="#/user/UserOutput">人员产出率</a>
                                </Menu.Item>
                            }
                            {
                                (isFIN ? FINCanViewUserEfficiency : !(isBD || isBDO || isBDM || (isCRC && isChargeArea) || isHRRC)) &&
                                <Menu.Item key="areaCityAnalysis">
                                    <a href="#/user/areaCityAnalysis">区域城市分析</a>
                                </Menu.Item>
                            }
                        </SubMenu>
                        }
                        {(!isBAL && !isBDO) &&
                            <SubMenu key="sub3" title={'绩效数据'}>
                            {
                                (isVP || isBO || isCSAL || isCRCM || isCRCC || isHRRC) &&
                                <Menu.Item key="crcPostRank">
                                    <a href="#/user/crcPostRank">CRC岗位排名</a>
                                </Menu.Item>
                            }
                            {
                                (isCRCC || isCRCM || isBO || isCSAL || isPML || isPM) &&
                                <Menu.Item key="crcTeamContributeScore">
                                    <a href="#/user/crcTeamContributeScore">CRC团队贡献度</a>
                                </Menu.Item>
                            }
                            {
                                (isBO || isCSAL || isCRCC || isCRCM) &&
                                <Menu.Item key="teamManageEvaluate">
                                    <a href="#/user/teamManageEvaluate">团队管理评价</a>
                                </Menu.Item>
                            }
                            {
                                (isBO || isCSAL || isPML) &&
                                <Menu.Item key="pmInfo">
                                    <a href="#/user/pmInfo">PM信息</a>
                                </Menu.Item>
                            }
                        </SubMenu>
                        }
                </Menu>
            </aside>
        );
    }
}

export default UserSider;



// WEBPACK FOOTER //
// ./src/components/user/UserSider.js